// Cell renderer that wraps the WorkflowStatusBadge, which itself wraps the Badge component
import React from "react"
import WorkflowStatusBadge from "../WorkflowStatusBadge"

const WorkflowStatusBadgeCell = ({ value, column, badgeKey, data, api }) => {
  const uniqueValues = React.useMemo(() => {
    if (data) {
      let rowData = []
      api.forEachNode((node) => rowData.push(node.data))
      return [...new Set(rowData.filter((data) => data?.[column?.colId]).map((data) => data?.[column?.colId]))]
    }
    return []
  }, [api, data])

  if (!value && !badgeKey) return null

  let badgeValue = data?.[badgeKey] || value

  return (
    <WorkflowStatusBadge
      uniqueValues={uniqueValues}
      value={badgeValue}
      isFlex
    />
  )
}

export default WorkflowStatusBadgeCell
